import { closestCenter, DndContext, DragEndEvent } from '@dnd-kit/core'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import { SeqWorkspaceItem } from './components/seq-workspace-item'
import { MilestoneItem } from '../../../../entities/workflow/types/workflow.types'

type SeqWorkspaceProps = {
  milestones: MilestoneItem[]
  onSeqChanged?: (newOrderedMilestones: MilestoneItem[]) => void
}

export const SeqWorkspace = ({ milestones, onSeqChanged }: SeqWorkspaceProps) => {
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event

    if (over && active.id !== over.id) {
      const oldIndex = milestones.findIndex((item) => item.id === active.id)
      const newIndex = milestones.findIndex((item) => item.id === over.id)

      const newOrderedMilestones = arrayMove(milestones, oldIndex, newIndex)

      onSeqChanged?.(newOrderedMilestones)
    }
  }

  return (
    <div style={{ maxWidth: '400px', margin: '0 auto' }}>
      <DndContext
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={milestones.map((item: any) => item.id)}
          strategy={verticalListSortingStrategy}
        >
          {milestones.map((milestone: MilestoneItem) => (
            <SeqWorkspaceItem
              key={milestone.id}
              id={milestone.id}
              text={milestone.name}
            />
          ))}
        </SortableContext>
      </DndContext>
    </div>
  )
}
